'use-client';
import LineShareButton from '../../LineShareButton';
import { WithConsentPolicy } from '../../../../ConsentPolicyWrapper/viewer/ConsentPolicyWrapper';

export default WithConsentPolicy(LineShareButton, {
  componentConsentPolicy: { advertising: true },
});
